/**
 * 沪深A股页面
 */

 import React from "react"
 import ReactDOM from "react-dom"
 import { Page_A } from "../components/page/a";
 
 if(window.quotedata){
   ReactDOM.render(
     <Page_A quotedata={window.quotedata}/>,
     document.getElementById('app')
   )  
 }
 
 